// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEvent } from "effector";
import {
  ProfileListDto,
  ProfileRightsListDto
} from "../../api/backend-openapi";

export const setProfileList = createEvent<ProfileListDto>("SET_PROFILE_LIST");

export const setProfileRightsList = createEvent<ProfileRightsListDto>(
  "SET_PROFILE_RIGHTS_LIST"
);
